import axios from 'axios';
import store from './../store';

axios.interceptors.response.use(
  function(response) {
    if (response.data.message) {
      window.$eventHub.$emit('showAlert', {
        message: response.data.message,
        type: 'success',
      });
    }

    if (response.data.data) {
      return response.data;
    }

    return response;
  },
  function(error) {
    if (error.response.data.message) {
      window.$eventHub.$emit('showAlert', {
        message: error.response.data.message,
        type: 'error',
      });
    }

    if (error.response.data.message === 'No authorization token was found') {
      store.dispatch('auth/flush');
    }

    return Promise.reject(error);
  },
);
